import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconGisSizeS from './IconGis_size_s';

const props: CreateIconArguments = {
  l: IconGisSizeS,
  m: IconGisSizeS,
  s: IconGisSizeS,
  xs: IconGisSizeS,
  name: 'IconGis',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
